export class Config {
  static environment = process.env.REACT_APP_WEBSITE_PUBLIC_NODE_ENV;
  static apiBaseUrl = process.env.REACT_APP_WEBSITE_API_BASE_URL;
  static apiAccessKey = process.env.REACT_APP_WEBSITE_API_ACCESS_KEY;
  static apiProxyUrl = process.env.REACT_APP_WEBSITE_API_PROXY_URL;
  static frontEndOrigin = process.env.REACT_APP_WEBSITE_PUBLIC_FRONT_END_ORIGIN;
}
